import React from 'react'
import Modal from '../../modals/wrapper'
import useClientLocation from '../../../hooks/use-client-location'
import { get } from 'lodash'
import moment from 'moment'
import useCourseEnrollability from '../../user/hooks/use-user-course-enrollability'
import Course from './course'
import { Spinner } from 'react-bootstrap'

const styleCenter = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
}

const ScheduleConflicts = () => {
    const { goBack, params } = useClientLocation()

    const experienceId = get(params, 'experienceId')

    const {
        isLoadingEnrollability,
        conflicts
    } = useCourseEnrollability({ courseId: experienceId })

    React.useEffect(() => {
        if (!isLoadingEnrollability && !conflicts.length) {
            goBack()
        }
    }, [isLoadingEnrollability, conflicts, goBack])
    

    const renderCourse = (courseId) => (<Course courseId={courseId} key={courseId} />)

    const renderGroup = (conflictGroup) => {
        const date = conflictGroup.date
        const courseIds = get(conflictGroup, 'courseIds', [])
        return (
            <React.Fragment key={date}>
                <div style={{ textAlign: 'center' }}>{moment(date, 'YYYY-MM-DD').format('MMMM Do YYYY')}</div>
                {courseIds.map(renderCourse)}
            </React.Fragment>
        )
    }

    const renderConflicts = () => {
        if (isLoadingEnrollability) {
            return (<div style={styleCenter}><Spinner animation="border" variant="primary" /></div>)
        }
        if (!conflicts.length) {
            return (<div style={styleCenter}><div>There are no conflicts to display!</div></div>)
        }
        return conflicts.map(renderGroup)
    }

    return (
        <Modal
            fullWidth
            closeButton
            onHide={goBack}
            closeStyle={{ color: 'white' }}
        >
            <div style={{ minHeight: '300px'}}>
                <div
                    style={{
                        backgroundColor: 'rgb(0, 105, 217)',
                        ...styleCenter
                    }}
                >
                    <div style={{ color: 'white', fontSize: '1.2em', padding: '20px' }}>
                        <strong>Conflicts</strong>
                    </div>
                </div>
                <div style={{ padding: '40px'}}>
                    {renderConflicts()}
                </div>
            </div>
        </Modal>
    )
}

export default ScheduleConflicts